import { render } from "./HeaderNavigationLink.vue?vue&type=template&id=d5365414&scoped=true"
import script from "./HeaderNavigationLink.vue?vue&type=script&lang=js"
export * from "./HeaderNavigationLink.vue?vue&type=script&lang=js"

import "./HeaderNavigationLink.vue?vue&type=style&index=0&id=d5365414&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5365414"]])

export default __exports__